/* L'Arte del Tessuto — Black Friday 2026 interactions (self-guarding, no deps) */
(function () {
  'use strict';
  var END = (window.LDT_BW && window.LDT_BW.end) || '2026-12-01T00:00:00+01:00';
  var endTs = new Date(END).getTime();
  var fmt = new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR' });
  function money(cents) { return fmt.format((cents || 0) / 100); }
  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function pad(n) { return n < 10 ? '0' + n : '' + n; }

  /* ---------- data ---------- */
  var DATA = {};
  try { var el = document.getElementById('ldt-bw-data'); if (el) DATA = JSON.parse(el.textContent); } catch (e) {}
  function product(handle) { return (DATA.products || {})[handle]; }
  function findVariant(handle, o1, o2) {
    var p = product(handle); if (!p) return null;
    for (var i = 0; i < p.variants.length; i++) {
      var v = p.variants[i];
      if ((o1 == null || v.o1 === o1) && (o2 == null || v.o2 === o2)) return v;
    }
    return null;
  }

  /* ---------- countdown ---------- */
  function tick() {
    var d = Math.max(0, endTs - Date.now());
    var days = Math.floor(d / 864e5), h = Math.floor(d % 864e5 / 36e5), m = Math.floor(d % 36e5 / 6e4), s = Math.floor(d % 6e4 / 1e3);
    $$('[data-bw-countdown]').forEach(function (c) {
      var map = { d: days, h: pad(h), m: pad(m), s: pad(s) };
      $$('[data-u]', c).forEach(function (n) { n.textContent = map[n.getAttribute('data-u')]; });
    });
    $$('[data-bw-countdown-inline]').forEach(function (c) {
      var _du = (window.LDT_I18N && LDT_I18N.cd && LDT_I18N.cd.d) || 'g';
      c.textContent = (days > 0 ? days + _du + ' ' : '') + pad(h) + 'h ' + pad(m) + 'm ' + pad(s) + 's';
    });
    if (d === 0) $$('[data-bw-hide-on-end]').forEach(function (n) { n.style.display = 'none'; });
  }
  tick(); setInterval(tick, 1000);

  /* ---------- toast ---------- */
  var toastEl;
  function toast(html) {
    if (!toastEl) { toastEl = document.createElement('div'); toastEl.className = 'bw-toast'; document.body.appendChild(toastEl); }
    toastEl.innerHTML = html; toastEl.classList.add('is-on');
    clearTimeout(toastEl._t); toastEl._t = setTimeout(function () { toastEl.classList.remove('is-on'); }, 3200);
  }

  /* ---------- cart ---------- */
  function addItems(items, btn) {
    if (btn) btn.classList.add('is-loading');
    var drawer = document.querySelector('cart-drawer');
    var body = { items: items };
    if (drawer) { body.sections = ['cart-drawer', 'cart-icon-bubble']; body.sections_url = window.location.pathname; }
    /* _fd=0 evita il redirect al dominio principale (che se è parcheggiato blocca l'aggiunta) */
    return fetch('/cart/add.js?_fd=0', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); }).then(function (res) {
      if (btn) btn.classList.remove('is-loading');
      if (res.status && res.description) { toast(res.description); return; }
      if (btn) { btn.classList.add('is-added'); setTimeout(function () { btn.classList.remove('is-added'); }, 2200); }
      if (drawer && res.sections && typeof drawer.renderContents === 'function') {
        try {
          res.id = (res.items && res.items[0] && res.items[0].variant_id) || items[0].id;
          drawer.classList.remove('is-empty');
          drawer.renderContents(res);
          return;
        } catch (e) { /* fall through */ }
      }
      window.location.href = (window.routes && window.routes.cart_url) || '/cart';
    }).catch(function () { if (btn) btn.classList.remove('is-loading'); toast((window.LDT_I18N&&LDT_I18N.msg&&LDT_I18N.msg.error)||'Ops, riprova tra un attimo.'); });
  }
  window.LDT_BW_add = addItems;

  /* ---------- product cards: swatches + quick add ---------- */
  document.addEventListener('click', function (e) {
    var sw = e.target.closest('.bw-sw');
    if (sw) {
      var card = sw.closest('[data-bw-card]'); if (!card) return;
      e.preventDefault();
      $$('.bw-sw', card).forEach(function (x) { x.classList.toggle('is-active', x === sw); });
      card.setAttribute('data-color', sw.getAttribute('data-color'));
      var img = $('.bw-card__img1', card);
      if (img && sw.getAttribute('data-img')) { img.src = sw.getAttribute('data-img'); img.removeAttribute('srcset'); }
      var lbl = $('[data-bw-color-lbl]', card); if (lbl) lbl.textContent = sw.getAttribute('data-color');
      syncSizes(card);
      return;
    }
    var size = e.target.closest('.bw-size');
    if (size) {
      var c = size.closest('[data-bw-card]'); if (!c) return;
      e.preventDefault();
      var v = findVariant(c.getAttribute('data-handle'), c.getAttribute('data-color'), size.getAttribute('data-size'));
      if (!v) return toast((window.LDT_I18N&&LDT_I18N.msg&&LDT_I18N.msg.unavailable)||'Taglia non disponibile');
      addItems([{ id: v.id, quantity: 1 }], size);
      return;
    }
    /* looks: add whole look */
    var lookBtn = e.target.closest('[data-bw-look-add]');
    if (lookBtn) {
      e.preventDefault();
      var look = lookBtn.closest('[data-bw-look]'); var items = [];
      var missing = false;
      $$('[data-bw-item]', look).forEach(function (it) {
        var v = resolveItem(it); if (v) items.push({ id: v.id, quantity: 1 }); else missing = true;
      });
      if (missing || !items.length) return toast((window.LDT_I18N&&LDT_I18N.msg&&LDT_I18N.msg.pickAll)||'Scegli colore e taglia per ogni capo');
      addItems(items, lookBtn);
      return;
    }
    /* single add (PDP add-ons / cart upsell) */
    var one = e.target.closest('[data-bw-add-one]');
    if (one) {
      e.preventDefault();
      var item = one.closest('[data-bw-item]'); var vv = resolveItem(item);
      if (!vv) return toast((window.LDT_I18N&&LDT_I18N.msg&&LDT_I18N.msg.pickSize)||'Scegli colore e taglia');
      addItems([{ id: vv.id, quantity: 1 }], one);
      return;
    }
    /* PDP: 1 capo / 2 capi. Colore e taglia si scelgono nel box e si aggiunge da qui (nessuno scroll) */
    var tier = e.target.closest('.bw-otier');
    if (tier) {
      e.preventDefault();
      offerPick(tier.closest('[data-bw-offer]'), tier.getAttribute('data-n'));
      return;
    }
    var pair = e.target.closest('[data-bw-bundle-add]');
    if (pair) {
      e.preventDefault();
      var ob = pair.closest('[data-bw-offer]'), msg = (window.LDT_I18N && LDT_I18N.msg) || {};
      if (pair.getAttribute('data-panel') === '1') {
        var one = rowVariant(ob, '1-1');
        if (!one) return toast(msg.pickSize || 'Scegli colore e taglia');
        return addItems([{ id: one.id, quantity: 1 }], pair);
      }
      var p1 = rowVariant(ob, '2-1'), p2 = rowVariant(ob, '2-2');
      if (!p1 || !p2) return toast(msg.pickAll || 'Scegli colore e taglia per ogni capo');
      addItems(p1.id === p2.id ? [{ id: p1.id, quantity: 2 }] : [{ id: p1.id, quantity: 1 }, { id: p2.id, quantity: 1 }], pair);
    }
  });

  function syncSizes(card) {
    var handle = card.getAttribute('data-handle'), color = card.getAttribute('data-color');
    $$('.bw-size', card).forEach(function (b) {
      var v = findVariant(handle, color, b.getAttribute('data-size'));
      b.disabled = !(v && v.available);
    });
  }
  $$('[data-bw-card]').forEach(syncSizes);

  function resolveItem(it) {
    if (!it) return null;
    var handle = it.getAttribute('data-handle');
    var vs = $('select[data-variant]', it);
    if (vs) { var p = product(handle); return p ? p.variants.filter(function (v) { return String(v.id) === vs.value; })[0] : { id: +vs.value }; }
    var s1 = $('select[data-opt="1"]', it), s2 = $('select[data-opt="2"]', it);
    var v = findVariant(handle, s1 ? s1.value : null, s2 ? s2.value : null);
    return v && v.available ? v : null;
  }

  /* ---------- PDP: offerta 1 capo / 2 capi ---------- */
  function eur(c) { var p = (c / 100).toFixed(2).split('.'); return '€' + p[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + p[1]; }
  function offerVariants(box) {
    if (!box._v) { try { box._v = JSON.parse($('[data-bw-offer-json]', box).textContent); } catch (err) { box._v = []; } }
    return box._v;
  }
  /* ogni riga ha una chiave "pannello-riga": 1-1 (1 capo), 2-1 e 2-2 (2 capi) */
  function rowSelects(box, key) { return $$('select[data-pr="' + key + '"]', box); }
  function rowMatch(box, key) {
    var sel = rowSelects(box, key);
    return offerVariants(box).filter(function (v) { return v.o.every(function (val, i) { return !sel[i] || sel[i].value === val; }); })[0] || null;
  }
  function rowVariant(box, key) { var v = rowMatch(box, key); return v && v.a ? v : null; }
  function rowFill(box, key, v) { rowSelects(box, key).forEach(function (s, i) { if (v.o[i] != null) s.value = v.o[i]; }); }
  /* come nel selettore del tema: le scelte esaurite si disattivano in ordine (colore, poi taglia) */
  function rowSync(box, key) {
    var vs = offerVariants(box), sel = rowSelects(box, key);
    sel.forEach(function (s, i) {
      $$('option', s).forEach(function (op) {
        op.disabled = !vs.some(function (v) {
          if (!v.a || v.o[i] !== op.value) return false;
          for (var j = 0; j < i; j++) if (v.o[j] !== sel[j].value) return false;
          return true;
        });
      });
      var cur = s.options[s.selectedIndex];
      if (cur && cur.disabled) { var ok = $$('option', s).filter(function (op) { return !op.disabled; })[0]; if (ok) s.value = ok.value; }
    });
    var parts = key.split('-'), panel = $('.bw-obundle[data-panel="' + parts[0] + '"]', box);
    var v = rowMatch(box, key), img = panel && $$('.bw-obundle__img', panel)[+parts[1] - 1];
    if (v && v.i && img && img.getAttribute('src') !== v.i) { img.src = v.i; img.removeAttribute('srcset'); }
  }
  function offerTotal(box) {
    var o = rowVariant(box, '1-1'), c1 = $('[data-bw-bundle-add][data-panel="1"]', box), t1 = $('[data-bw-bundle-total="1"]', box);
    if (c1) c1.disabled = !o;
    if (o && t1) t1.textContent = eur(o.p);
    var a = rowVariant(box, '2-1'), b = rowVariant(box, '2-2'), c2 = $('[data-bw-bundle-add][data-panel="2"]', box);
    if (c2) c2.disabled = !(a && b);
    if (!a || !b) return;
    var sum = a.p + b.p, off = Math.round(sum * 0.9), t2 = $('[data-bw-bundle-total="2"]', box), s = $('[data-bw-bundle-save]', box);
    if (t2) t2.textContent = eur(off);
    if (s) s.textContent = eur(sum - off);
  }
  function offerInfo(box) { return box.closest('product-info, .product__info-container') || document; }
  /* la variante scelta nella pagina (campo nascosto del modulo d'acquisto) */
  function pageVariant(box) {
    var el = offerInfo(box).querySelector('form[action*="/cart/add"] [name="id"]');
    return el ? offerVariants(box).filter(function (v) { return String(v.id) === el.value; })[0] || null : null;
  }
  /* pagina -> box (sola lettura) */
  function fromPage(box) {
    var v = pageVariant(box);
    if (!v) return;
    rowFill(box, '1-1', v); rowSync(box, '1-1'); offerTotal(box);
  }
  /* il tema, cambiando colore, porta la pagina alla foto: se la scelta parte dal box la pagina deve restare ferma */
  function quiet(fn) {
    var orig = Element.prototype.scrollIntoView;
    Element.prototype.scrollIntoView = function () {
      if (this.closest && this.closest('media-gallery')) return;
      return orig.apply(this, arguments);
    };
    try { fn(); } finally { setTimeout(function () { Element.prototype.scrollIntoView = orig; }, 900); }
  }
  /* box -> pagina: stessa strada del selettore del tema (prezzo, foto, pulsanti e PayPal restano coerenti) */
  function toPage(box, v) {
    var picker = offerInfo(box).querySelector('variant-radios, variant-selects');
    if (!picker) return;
    var last = null;
    if (picker.tagName === 'VARIANT-RADIOS') {
      $$('fieldset', picker).forEach(function (fs, i) {
        var r = $$('input[type="radio"]', fs).filter(function (x) { return x.value === v.o[i]; })[0];
        if (r && !r.checked) { r.checked = true; last = r; }
      });
    } else {
      $$('select', picker).forEach(function (s, i) { if (s.value !== v.o[i]) { s.value = v.o[i]; last = s; } });
    }
    if (last) quiet(function () { last.dispatchEvent(new Event('change', { bubbles: true })); });
  }
  function offerPick(box, n) {
    if (!box) return;
    var two = n === '2', info = offerInfo(box);
    $$('.bw-otier', box).forEach(function (t) {
      var on = t.getAttribute('data-n') === n, w = t.closest('.bw-otier-w');
      t.setAttribute('aria-checked', on ? 'true' : 'false');
      if (w) w.classList.toggle('is-active', on);
    });
    $$('.bw-obundle', box).forEach(function (p) { p.hidden = p.getAttribute('data-panel') !== n; });
    if (two) {
      /* si parte dal colore e dalla taglia scelti nella pagina, se le righe non sono già state cambiate a mano */
      var cur = pageVariant(box);
      ['2-1', '2-2'].forEach(function (k) {
        if (cur && !box['_t' + k]) rowFill(box, k, cur);
        rowSync(box, k);
      });
    } else {
      fromPage(box);
    }
    offerTotal(box);
    /* con 2 capi si compra dal box: selettore e pulsanti del tema restano nascosti */
    if (info.classList) info.classList.toggle('bw-bundle-on', two);
  }
  document.addEventListener('change', function (e) {
    var s = e.target.closest && e.target.closest('.bw-obundle__sel');
    if (s) {
      var box = s.closest('[data-bw-offer]'), key = s.getAttribute('data-pr');
      box['_t' + key] = true;
      rowSync(box, key);
      offerTotal(box);
      if (key === '1-1') { var v = rowMatch(box, key); if (v && v.a) toPage(box, v); }
      return;
    }
    /* la scelta fatta nel selettore della pagina arriva nel box */
    if (e.target.closest && e.target.closest('variant-radios, variant-selects')) {
      setTimeout(function () { $$('[data-bw-offer]').forEach(fromPage); }, 0);
    }
  });
  document.addEventListener('keydown', function (e) {
    var t = e.target.closest && e.target.closest('.bw-otier');
    if (!t || ['ArrowDown', 'ArrowUp', 'ArrowLeft', 'ArrowRight'].indexOf(e.key) < 0) return;
    e.preventDefault();
    var box = t.closest('[data-bw-offer]'), all = $$('.bw-otier', box), i = all.indexOf(t);
    var next = all[(i + (e.key === 'ArrowDown' || e.key === 'ArrowRight' ? 1 : all.length - 1)) % all.length];
    next.focus(); offerPick(box, next.getAttribute('data-n'));
  });
  $$('[data-bw-offer]').forEach(function (box) {
    ['1-1', '2-1', '2-2'].forEach(function (k) { rowSync(box, k); });
    fromPage(box);
  });

  /* look image swap + live totals */
  document.addEventListener('change', function (e) {
    var s = e.target.closest('select[data-opt="1"]');
    if (!s) return;
    var it = s.closest('[data-bw-item]'); if (!it) return;
    var v = findVariant(it.getAttribute('data-handle'), s.value, null);
    var img = $('img', it);
    if (v && v.img && img) { img.src = v.img; img.removeAttribute('srcset'); }
    var look = it.closest('[data-bw-look]');
    if (look) {
      var idx = it.getAttribute('data-idx'); var big = $('[data-bw-look-img="' + idx + '"]', look);
      if (big && v && v.img) { big.src = v.img; big.removeAttribute('srcset'); }
    }
  });

  /* ---------- reveal on scroll (robusto: mai testo invisibile) ---------- */
  document.documentElement.classList.add('bw-js');
  function bwRevealAll(root) { $$('.bw-reveal', root).forEach(function (n) { n.classList.add('is-in'); }); }
  function bwObserve(root) {
    if (!('IntersectionObserver' in window)) { bwRevealAll(root); return; }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -5% 0px', threshold: .01 });
    $$('.bw-reveal:not(.is-in)', root).forEach(function (n) { io.observe(n); });
  }
  bwObserve(document);
  /* rete di sicurezza: dopo 2,5s tutto visibile comunque */
  setTimeout(function () { bwRevealAll(document); }, 2500);
  /* editor tema: le sezioni ri-renderizzate restano visibili */
  if (window.Shopify && Shopify.designMode) { bwRevealAll(document); }
  document.addEventListener('shopify:section:load', function (e) { bwRevealAll(e.target); });

  /* ---------- hero parallax (subtle) ---------- */
  var stage = $('.bw-hero__stage');
  if (stage && window.matchMedia('(pointer:fine)').matches && !window.matchMedia('(prefers-reduced-motion:reduce)').matches) {
    stage.addEventListener('mousemove', function (e) {
      var r = stage.getBoundingClientRect();
      var x = (e.clientX - r.left) / r.width - .5, y = (e.clientY - r.top) / r.height - .5;
      stage.style.transform = 'rotateY(' + (x * 6) + 'deg) rotateX(' + (-y * 6) + 'deg)';
    });
    stage.addEventListener('mouseleave', function () { stage.style.transform = ''; });
    stage.style.transition = 'transform .6s cubic-bezier(.2,.7,.2,1)'; stage.style.transformStyle = 'preserve-3d';
  }
})();
